import { useEffect, useRef, useState } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@material-ui/core";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import GetAppIcon from '@material-ui/icons/GetApp';
import {
  BootstrapInput,
  tableIcons,
  baseApiURL,
} from "../../Utilities/Utility";
import Button from "@material-ui/core/Button";
import { GetSuppliers, GetApprovedInspection ,rejectReport } from "../../Redux/APIs/api_Pdir";
import debounce from "lodash.debounce";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useSelector } from "react-redux";
import MaterialTable from "material-table";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import SnackbarCustom from "../../Components/Snackbar/Snackbar";
import Loading from "../../Components/Loader/Loader";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

//import { toast } from 'react-toastify';

export default function ListInspection() {
  const navigate = useNavigate();
  const tableHeaderStyle = {
    backgroundColor: "var(--light-sand)",
    color: "var(--dark-blue)",
  };
  const tableOptions = {
    headerStyle: tableHeaderStyle,
    showTitle: false,
    draggable: false,
    pageSize: 5,
    pageSizeOptions: [5, 10, 25, 50],
    paginationPosition: "bottom",
    maxBodyHeight: "600px",
  };
  const [dateInputs, setDateInputs] = useState({
    fromDate: null,
    toDate: null,
  });
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [open, setOpen] = useState(false);

  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };

  const handleClose = (e) => {
    setOpen(false);
  };

  const [tableData, setTableData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [inspectionNumber, setInspectionNumber] = useState("");
  const [supplierId, setSupplierId] = useState("");
  const tableRef = useRef();
  function handleDateChange(event, value) {
    let elem = event.target.name;
    switch (elem) {
      case "fromDate":
        setDateInputs({
          ...dateInputs,
          fromDate: event.target.value,
        });
        break;
      case "toDate":
        setDateInputs({
          ...dateInputs,
          toDate: event.target.value,
        });
        break;
      default:
        break;
    }
  }
  const [supplierList, SetSupplierList] = useState([]);
  const azureToken = useSelector((state) => state.saveTokenReducer);
  const UID = useSelector((state) => state.saveUserIdReducer);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const siteToken = useSelector((state) => state.saveBearerTokenReducer);
  const [openReject, setOpenReject] = useState(false);
  const [rejectRemarks, setRejectRemarks] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [originalData, setOriginalData] = useState([]);


  const [formData, setFormData] = useState({
    supplierCode: "",
    supplierId: "",
    supplierName: "",
  });
  const navigateToAddInspection = (rowData) => {
    navigate("/addInspection", { state: { ...rowData, from: '/listInspection' } });
  };
  

  const allowedRolesForDownload = [1, 2, 6, 12];

  var columns = [
    {
      title: "Inspection Number.",
      field: "inspectionNumber",
      render: (rowData) => (
        <Button
          variant="contained"
          onClick={() => navigateToAddInspection(rowData)}
          sx={{
            backgroundColor: "#1976d2 !important",
            color: "#ffffff !important",
            boxShadow: "none !important",
            textTransform: "none",
            minWidth: "120px",
            "&:hover": {
              backgroundColor: "#115293 !important",
            },
          }}
        >
          {rowData.inspectionNumber}
        </Button>
      ),
    },
    { title: "Report Name", field: "reportName" },
    { title: "Part Number", field: "partNo" },
    { title: "Part Description", field: "description" },
    { title: "Supplier Name", field: "supplierName" },
    { title: "Po No", field: "pono" ,width:"300px" },
    { title: "Batch No.", field: "lotNoBatchNoRouteSheet" },

    

    {
      title: "Action to be Taken",
      field: "status",
      sorting: false,
      render: (rowData) => {
        const isEnabled = rowData.statusName === "Acknowledged by IQC Engineer" && userDetails.roleId === 12;
    
        return (
          <>
            <IconButton
              onClick={() => handleStatusUpdate(rowData, "APPROVE")}
              disabled={!isEnabled}
            >
              <CheckCircleIcon
                style={{ color: isEnabled ? "green" : "grey" }}
              />
            </IconButton>
    
            <IconButton
              onClick={() => handleOpenRejectPopup(rowData)}
              disabled={!isEnabled}
            >
              <CancelIcon
                style={{ color: isEnabled ? "red" : "grey" }}
              />
            </IconButton>
          </>
        );
      },
    },
    
    { title: "Status", field: "statusName" },

    ...(allowedRolesForDownload.includes(userDetails.roleId)
      ? [
          {
            title: "Report Download",
            field: "reportDownload",
            render: (rowData) => (
              <IconButton
                color="primary"
                onClick={() => handleReportDownload(rowData)}
              >
                <CloudDownloadIcon style={{ color: "#1976d2" }} />
              </IconButton>
            ),
          },
        ]
      : []),

    { title: "Created Date", field: "createdDate", render: rowData => {
      if (!rowData.createdDate) return ""; 
      const date = new Date(rowData.createdDate);
      // format: YYYY-MM-DD
      return date.toISOString().split("T")[0];
    }, },
  ];


  const handleOpenRejectPopup = (row) => {
    setSelectedRow(row);
    setRejectRemarks("");
    setOpenReject(true);
  };
  
  const handleCloseRejectPopup = () => {
    setOpenReject(false);
  };
  

  useEffect(() => {
    console.log("userdetail", userDetails);
    //console.log('formdata',formData.supplierId);

    getTableData();
  }, []);


  const handleReset = () => {
    setDateInputs({ fromDate: "", toDate: "" });
      setFormData((prev) => ({ ...prev, supplierId: "" }));
      setTableData(originalData); 

  };
  


  const handleReportDownload = async (rowData) => {
    try {
        setIsLoader(true);
      const inspectionNumber = rowData.inspectionNumberId;
  
      const response = await fetch(
        `${baseApiURL}/PDIR/GeneratePDF?InspectionNumber=${inspectionNumber}`,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken.token,
            UserEmail: userDetails.userEmail,
            RoleName: userDetails.role,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            userId: UID.id,
          },
        }
      );
  
      if (!response.ok) {
        throw new Error("Failed to download report");
      }
  
      const blob = await response.blob();
  
      
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${inspectionNumber}_Inspection_Report.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
  
    } catch (error) {
      console.error("Download error:", error);
      alert("Report download failed");
    }
    finally {
        setIsLoader(false); 
      }
  };
  

  const handleStatusUpdate = (rowData) => {
    const inspectionNumberId = rowData.inspectionNumberId;
    const userId = userDetails.userId;
  
    const url = `${baseApiURL}/PDIR/ApproveReport`;
    const params = `?InspectionNumberId=${inspectionNumberId}&ApproverId=${userId}`;
  
    setIsLoader(true);
  
    fetch(`${url}${params}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + siteToken.token,
        AzureToken: azureToken.token,
        userId: UID.id,
        UserEmail: userDetails.userEmail,
        RoleName: userDetails.role,
        Gid: userDetails.gid,
        Roleid: userDetails.roleId,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.result?.response) {
          handleSnackOpen(data.result.responseMsg || "Approve successful");
        } else {
          handleSnackOpen(data.result.responseMsg || "Approve failed");
        }
        getTableData(); 
      })
      .catch((err) => {
        console.error(err);
        handleSnackOpen("Exception: " + err);
      })
      .finally(() => {
        setIsLoader(false);
      });
  };
  


  const handleRejectConfirm = () => {
    if (!rejectRemarks.trim()) {
      handleSnackOpen("Please enter remarks", "warning");
      return;
    }
  
    setIsLoader(true);
  
    const inspectionNumberId = selectedRow.inspectionNumberId;
    const rejectedId = userDetails.userId;
  
    rejectReport(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      inspectionNumberId,
      rejectedId,
      rejectRemarks
    )
      .then((response) => {
        if (response?.response) {
          handleSnackOpen(response.responseMsg, "success");
          setOpenReject(false);
          getTableData(); 
        } else {
          handleSnackOpen(response.responseMsg, "error");
        }
        setIsLoader(false);
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };
  

  const handleSearch = () => {
    const body = {
      UserId: userDetails.userId,
      FromDate: dateInputs.fromDate || null,   // agar empty string ho to null
      ToDate: dateInputs.toDate || null,
      PartId: null,
      ReportName: null,
      SupplierId: formData.supplierId || null,  // supplierId ya null
      InspectionNumber: null,
    };
  
    fetch(`${baseApiURL}/PDIR/SearchInspectionDetails`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + siteToken.token,
        AzureToken: azureToken.token,
        UserEmail: userDetails.userEmail,
        RoleName: userDetails.role,
        Gid: userDetails.gid,
        Roleid: userDetails.roleId,
        userId: UID.id,
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Search Result", data);
        setTableData(data.result.objResult);
      })
      .catch((err) => console.error(err));
  };
  
  const fetchSuppliers = debounce((value, callback) => {
    if (value.length >= 3) {
      GetSuppliers(
        siteToken.token,
        azureToken.token,
        UID.id,
        userDetails.userEmail,
        userDetails.gid,
        userDetails.role,
        userDetails.roleId,
        value
      ).then((data) => {
        console.log("data autocomplete supplier", data);
        callback(data || []);
      });
    }
  }, 400);

  function getTableData() {
    setIsLoader(true);
    GetApprovedInspection(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setTableData(response.objResult);
        setOriginalData(response.objResult);
        setIsLoader(false);
      })
      .catch((error) => {
        //handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }

   const downloadExcel = (data, fileName) => {
    const filteredData = data.map(row => ({
      "Inspection Number": row.inspectionNumber,
      "Report Name": row.reportName,
      "Part Number": row.partNo,
      "Part Description": row.description,
      "Supplier Name": row.supplierName,
      "Po No": row.pono,
      "Batch No":row.lotNoBatchNoRouteSheet,
      "Commodity Name":row.commodity,
      //"Product":row.productTypeId,
      "Product Name":row.productType,
      "Observation":row.observation,
      "Work Order No":row.workOrdeNo,
      "Lot Quantity":row.lotQuantity,
      //"Sample Quantity":row.sampleQuantity,
      "Batch Number":row.lotNoBatchNoRouteSheet,
      "Status":row.statusName,
      "Created Date": row.createdDate ? new Date(row.createdDate).toISOString().split("T")[0] : "",
      "Modified Date": row.modifiedDate ? new Date(row.modifiedDate).toISOString().split("T")[0] : ""



      
    }));
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
  
    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
  
    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <>
      

          <Grid item xs={12} className="left-div">
              <h3 className="heading">List of Inspection Report</h3>
          </Grid>
      <Grid container className="bg-card" spacing={2} style={{ marginTop: 16 }}>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth
          
          >
            <InputLabel shrink htmlFor="bootstrap-input">
              From Date
            </InputLabel>
            <BootstrapInput
              type="date"
              id="bootstrap-input"
              name="fromDate"
              onChange={handleDateChange}
              value={dateInputs.fromDate}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              To Date
            </InputLabel>
            <BootstrapInput
              type="date"
              id="bootstrap-input"
              name="toDate"
              onChange={handleDateChange}
              value={dateInputs.toDate}
              
              
            />
          </FormControl>
              </Grid>


              <Grid item xs={12} sm={6} md={3} >
                  <FormControl fullWidth variant="standard">
                     

                      <InputLabel shrink id="supplier-label" sx={{ opacity: 0, fontSize: '12px', color: '#6c757d', position: 'relative', top: '0px', left: '0px', transform: 'none', Bottom: '40px', backgroundColor: 'none' }}>
                          Supplier name
                      </InputLabel>


                      <Autocomplete sx={{ mt: '10px' }}
                          style={{ marginTop: '20px' }}
                          freeSolo
                          options={supplierList}
                          value={
                              supplierList.find((s) => s.supplierId === formData.supplierId) ||
                              null
                          }
                          getOptionLabel={(option) => option?.supplierName || ""}
                          isOptionEqualToValue={(option, value) =>
                              option.supplierId === value.supplierId
                          }
                          onInputChange={(event, value) => {
                              // fetch suppliers on typing
                              fetchSuppliers(value, (list) => {
                                  SetSupplierList(list);
                              });

                              // user typing → reset supplierId
                              setFormData((prev) => ({
                                  ...prev,
                                  supplierName: value,
                                  supplierId: "",
                                  supplierCode: "",
                              }));
                          }}
                          onChange={(event, value) => {
                              if (!value) {
                                  setFormData((prev) => ({
                                      ...prev,
                                      supplierId: "",
                                      supplierName: "",
                                      supplierCode: "",
                                  }));
                                  return;
                              }

                              // option selected
                              setFormData((prev) => ({
                                  ...prev,
                                  supplierId: value.supplierId,
                                  supplierName: value.supplierName,
                                  supplierCode: value.supplierCode,
                              }));
                          }}

                          renderInput={(params) => (
                              <TextField

                                  {...params}
                                  label={null}
                                  variant="standard"
                                  InputProps={{
                                      ...params.InputProps,
                                      inputComponent: BootstrapInput,
                                      disableUnderline: true,
                                  }}
                                  style={{
                                      width: '100%', padding: '0px',
                                  }}
                             
                              />

                          )}
                      />
                  </FormControl>
              </Grid>

      

        <Grid item xs={12} sm={6} md={3} style={{ marginTop: 25 }}>
  <div style={{
       display: "flex",
       justifyContent: "flex-start",
       gap: 16,
      }}> 
    <Button
      variant="contained"
       className="pt-button--primary button-submit"
      onClick={handleSearch}
    >
      Filter Result
    </Button>
    <Button
      variant="contained"
      onClick={handleReset}
      className="pt-button--primary button-submit"
    >
      Reset
    </Button>
  </div>
        </Grid>


       
      </Grid>
      <Grid container className="bg-card" spacing={2}>
        <Grid item xs={12} className="matTable" style={{ marginTop: "15px" }}>
          <MaterialTable
            tableRef={tableRef}
            //actions={actions}
            columns={columns}
            data={tableData}
            icons={tableIcons}
            isLoading={isLoader}
            options={tableOptions}
            actions={[
              {
                icon: () => <GetAppIcon  />,  // download icon
                tooltip: "Download Excel",
                isFreeAction: true,
                onClick: () => downloadExcel(tableData, "Exported_Data"),
              },
            ]}
            
          />
        </Grid>
        <>
          <SnackbarCustom
            open={open}
            message={snackMessage}
            alertType={alertType}
            handleClose={handleClose}
          />

        </>
         {isLoader ? <Loading loaderText="Loading...." /> : <></>}
         <Dialog open={openReject} onClose={handleCloseRejectPopup} maxWidth="sm" fullWidth>
  <DialogTitle>Reject Inspection Report</DialogTitle>

  <DialogContent>
    <TextField
      label="Remarks"
      fullWidth
      multiline
      minRows={3}
      value={rejectRemarks}
      onChange={(e) => setRejectRemarks(e.target.value)}
      margin="dense"
    />
  </DialogContent>

  <DialogActions>
    <Button onClick={handleCloseRejectPopup}>Cancel</Button>
    <Button
      variant="contained"
      color="error"
       onClick={handleRejectConfirm}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>

      </Grid>
    </>
  );
}
